var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57692 6.63312L1.60393 0.347811C1.23701 -0.115937 0.642112 -0.115937 0.275191 0.347811C-0.0917303 0.811558 -0.0917303 1.56344 0.275191 2.02719L5.91255 9.15219C6.27947 9.61594 6.87437 9.61594 7.24129 9.15219L12.8787 2.02719C13.2456 1.56344 13.2456 0.811558 12.8787 0.347811C12.5117 -0.115937 11.9168 -0.115937 11.5499 0.347811L6.57692 6.63312Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5479_343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57692 6.63312L1.60393 0.347811C1.23701 -0.115937 0.642112 -0.115937 0.275191 0.347811C-0.0917303 0.811558 -0.0917303 1.56344 0.275191 2.02719L5.91255 9.15219C6.27947 9.61594 6.87437 9.61594 7.24129 9.15219L12.8787 2.02719C13.2456 1.56344 13.2456 0.811558 12.8787 0.347811C12.5117 -0.115937 11.9168 -0.115937 11.5499 0.347811L6.57692 6.63312Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5479_343)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdown_icon.114f3fc15e7da7668de93c7b8036a3c3.svg";
export { ForwardRef as ReactComponent };